module.exports = __webpack_public_path__ + "static/media/manual-planos-e-coberturas.6471d026.pdf";